export class SpecialPriceProduct {
   constructor(id_producto, precio_base, precio_neto){
      this.id_producto = id_producto
      this.precio_base = precio_base
      this.precio_neto = precio_neto
   } 

   static fromServiceSpecialPriceProduct (special_price_product) {
      return new SpecialPriceProduct(
         special_price_product.ID_Producto,
         special_price_product.Precio_Base,
         special_price_product.Precio_Neto
         );
   }
}